import { Button } from '@cian/ui-kit';
import { IButtonProps } from '@cian/ui-kit/button/types';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './ActionButton.css';

export interface IActionButton extends Omit<IButtonProps, 'onClick'> {
  afterIcon?: IButtonProps['beforeIcon'];
  actionButtonHandle: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ActionButton = ({ beforeIcon, afterIcon, actionButtonHandle, ...rest }: IActionButton) => {
  const icon = beforeIcon || afterIcon;

  return (
    <div className={classNames(styles['wrapper'], afterIcon && styles['_with-after-icon'])}>
      <Button beforeIcon={icon} onClick={actionButtonHandle} {...rest} fullWidth={true} />
    </div>
  );
};
